// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import building01Icon from "@/assets/icons/building-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Building01IconProps = Omit<IconProps, "name">;

export function Building01Icon(props: Building01IconProps): React.ReactNode {
  return <Icon name={building01Icon} {...props} />;
}
